var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NUMBER_of_COMMUNITY_",
    "data-name": "NUMBER of COMMUNITY  ",
    transform: "translate(-915 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4274",
    "data-name": "Rectangle 4274",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(915 352)",
    fill: "#f0f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "community",
    d: "M15.5,24.5A5.5,5.5,0,1,0,10,30,5.51,5.51,0,0,0,15.5,24.5Zm-8,0A2.5,2.5,0,1,1,10,27,2.5,2.5,0,0,1,7.5,24.5Zm-5,12v4A1.5,1.5,0,0,0,4,42H16a1.5,1.5,0,0,0,1.5-1.5v-4A5.51,5.51,0,0,0,12,31H8a5.51,5.51,0,0,0-5.5,5.5Zm3,0A2.5,2.5,0,0,1,8,34h4a2.5,2.5,0,0,1,2.5,2.5V39h-9ZM38,19a5.5,5.5,0,1,0,5.5,5.5A5.51,5.51,0,0,0,38,19Zm0,8a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,38,27Zm2,4H36a5.51,5.51,0,0,0-5.5,5.5v4A1.5,1.5,0,0,0,32,42H44a1.5,1.5,0,0,0,1.5-1.5v-4A5.51,5.51,0,0,0,40,31Zm2.5,8h-9V36.5A2.5,2.5,0,0,1,36,34h4a2.5,2.5,0,0,1,2.5,2.5Zm-13-25.5A5.5,5.5,0,1,0,24,19,5.51,5.51,0,0,0,29.5,13.5Zm-8,0A2.5,2.5,0,1,1,24,16,2.5,2.5,0,0,1,21.5,13.5ZM30,31a1.5,1.5,0,0,0,1.5-1.5v-4A5.51,5.51,0,0,0,26,20H22a5.51,5.51,0,0,0-5.5,5.5v4A1.5,1.5,0,0,0,18,31ZM19.5,25.5A2.5,2.5,0,0,1,22,23h4a2.5,2.5,0,0,1,2.5,2.5V28h-9Z",
    transform: "translate(937.5 374)",
    fill: "#0012ad"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberCommunity);
export default __webpack_public_path__ + "static/media/NUMBER-COMMUNITY.54d99a6e314283f37fcea365913f818c.svg";
export { ForwardRef as ReactComponent };